module.exports = __webpack_public_path__ + "img/bgz.75c6d5c8.png";